<template>
  <ul class="breadcrumb">
    <li class="breadcrumb_item"><a href="/">HOME</a></li>
    <li class="breadcrumb_item"><a href="/product_top/">商品紹介</a></li>
    <li class="breadcrumb_item">{{this.heading}}</li>
  </ul>
</template>
<script>
export default {
  name: 'Route_Bread_Crumb',
  data () {
    return {
      heading: '',
    }
  },
  mounted: function () {
    this.createData()
    // fix for IE 11
    if (!!window.MSInputMethodContext && !!document.documentMode) {
	  window.addEventListener('hashchange', () => {
        var currentPath = window.location.hash.slice(1)
        if (this.$route.path !== currentPath) {
          this.$router.push(currentPath)
        }
      }, false)
    }
  },
  watch: {
    '$route' (to, from) {
      if (to.params.id) {
        switch (to.name) {
          case 'Home':
            this.heading = '家庭用商品一覧'
            break
          case 'Business':
            this.heading = '業務用商品一覧'
            break
          case 'Gift':
            this.heading = 'ギフト用商品一覧'
            break
        }
      } else {
        switch (to.path) {
          case '/home/':
            this.heading = '家庭用商品一覧'
            break
          case '/business/':
            this.heading = '業務用商品一覧'
            break
          case '/gift/':
            this.heading = 'ギフト用商品一覧'
            break
          default:
            this.heading = '家庭用商品一覧'
            break
        }
      }
    }
  },
  methods: {
    createData () {
      if (Object.keys(this.$route.params).length !== 0) {
        switch (this.$route.name) {
          case 'Home':
            this.heading = '家庭用商品一覧'
            break
          case 'Business':
            this.heading = '業務用商品一覧'
            break
          case 'Gift':
            this.heading = 'ギフト用商品一覧'
            break
        }
      } else {
        switch (this.$route.path) {
          case '/home/':
            this.heading = '家庭用商品一覧'
            break
          case '/business/':
            this.heading = '業務用商品一覧'
            break
          case '/gift/':
            this.heading = 'ギフト用商品一覧'
            break
          default:
            this.heading = '家庭用商品一覧'
            break
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/RouteBreadCrumb.vue